<template>
  <div class="pl-theme-switch">
    <span :id="labelId" class="pl-theme-switch__label">Motyw</span>
    <div class="pl-theme-switch__options" role="radiogroup" :aria-labelledby="labelId">
      <button
        v-for="option in modes"
        :key="option.value"
        type="button"
        role="radio"
        class="pl-theme-switch__option"
        :class="{ 'pl-theme-switch__option--active': mode === option.value }"
        :aria-checked="mode === option.value ? 'true' : 'false'"
        @click="setMode(option.value)"
      >
        <PlIcon :name="ICONS[option.value]" :size="14" />
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
let switchCount = 0
</script>

<script setup>
import { useColorScheme } from '@/theme/mode'
import PlIcon from './PlIcon.vue'

// Przełącznik motywu: systemowy / jasny / ciemny (zapamiętywany w przeglądarce).
const { mode, modes, setMode } = useColorScheme()

const ICONS = { system: 'monitor', light: 'sun', dark: 'moon' }
const labelId = `pl-theme-${++switchCount}`
</script>

<style scoped>
.pl-theme-switch {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 12px 12px;
}

.pl-theme-switch__label {
  font: var(--pl-type-overline);
  color: var(--pl-color-text-faint);
}

.pl-theme-switch__options {
  display: flex;
  padding: 3px;
  border: 1px solid var(--pl-color-border-subtle);
  border-radius: var(--pl-radius-pill);
  background: var(--pl-color-bg-sunken);
}

.pl-theme-switch__option {
  display: inline-flex;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  gap: 5px;
  min-height: 34px;
  padding: 6px 8px;
  border: 0;
  border-radius: var(--pl-radius-pill);
  background: none;
  color: var(--pl-color-text-secondary);
  font: var(--pl-type-caption-strong);
  white-space: nowrap;
  cursor: pointer;
}

.pl-theme-switch__option:hover {
  color: var(--pl-color-text-primary);
}

.pl-theme-switch__option--active {
  background: var(--pl-color-bg-card);
  color: var(--pl-color-text-primary);
  box-shadow: inset 0 0 0 1px var(--pl-color-border-strong);
}
</style>
